
import {
  defineComponent,
  reactive,
  watch,
  ref,
  onMounted,
} from 'vue';

export default defineComponent({
  props: {
    expanded: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    duration: {
      type: Number,
      required: false,
      default: () => 0.575,
    },
  },

  setup(props) {
    const root = ref<InstanceType<typeof HTMLElement>>();
    const isExpanded = reactive({ value: props.expanded });

    watch(() => props.expanded, () => {
      isExpanded.value = props.expanded;
    });

    const enter = (element: HTMLElement) => {
      const $el = element;
      const { width } = getComputedStyle($el);

      $el.style.width = width;
      $el.style.position = 'absolute';
      $el.style.visibility = 'hidden';
      $el.style.height = 'auto';

      const { height } = getComputedStyle($el);

      $el.style.width = '';
      $el.style.position = '';
      $el.style.visibility = '';
      $el.style.height = '0';

      const heightFix = getComputedStyle($el).height;

      requestAnimationFrame(() => {
        $el.style.height = height;
      });

      return heightFix;
    };

    const afterEnter = (element: HTMLElement) => {
      const $el = element;

      $el.style.height = 'auto';
    };

    const leave = (element: HTMLElement) => {
      const $el = element;
      const { height } = getComputedStyle($el);

      $el.style.height = height;

      const heightFix = getComputedStyle($el).height;

      requestAnimationFrame(() => {
        $el.style.height = '0';
      });

      return heightFix;
    };

    onMounted(() => {
      if (root.value) {
        root.value.style.setProperty('--expansion-duration', `${props.duration}s`);
      }
    });

    return {
      root,
      isExpanded,
      enter,
      afterEnter,
      leave,
    };
  },
});
